export const monthNamesFull = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const weekdayNamesLetter = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
